<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name 面会種別
      .right-side
        slot(name="question")

    .register-value.reservation-type-radios(v-if="_showReservationButtons && _showOnlineReservationButtons")
      label.register-radio-label
        input#type-1.register-radio-form(
          v-model="_value"
          name="reservation-type"
          type="radio"
          :value="0"
          v-validate="{ required: true }"
          data-vv-as="面会種別")
        span.register-radio-text 訪問面会
      label.register-radio-label
        input#type-2.register-radio-form(v-model="_value" name="reservation-type" type="radio" :value="1")
        span.register-radio-text オンライン面会

    .register-value.reservation-type-radios(v-if="_showReservationButtons && !_showOnlineReservationButtons")
      label.register-radio-label
        input#type-1.register-radio-form(
          v-model="_value"
          name="reservation-type"
          type="radio"
          :value="0"
          v-validate="{ required: true }"
          data-vv-as="面会種別")
        span.register-radio-text 訪問面会

    .register-value.reservation-type-radios(v-if="!_showReservationButtons && _showOnlineReservationButtons")
      label.register-radio-label
        input#type-1.register-radio-form(
          v-model="_value"
          name="reservation-type"
          type="radio"
          :value="1"
          v-validate="{ required: true }"
          data-vv-as="面会種別")
        span.register-radio-text オンライン面会

    .error-messages(v-for="error in errors.collect('reservation-type')")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { userStore } from "@/store/store";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputReservationType extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true, type: Number })
  private value!: number;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): number {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: number) {
    this.$emit("input", newValue);
    return;
  }

  /** 訪問面会ボタンを表示するかを返す */
  get _showReservationButtons(): boolean {
    return userStore.facility.permittedFunctions.reservation;
  }

  /** オンライン面会ボタンを表示するかを返す */
  get _showOnlineReservationButtons(): boolean {
    return userStore.facility.permittedFunctions.onlineReservation;
  }
}
</script>

<style lang="scss" scoped>
// ラジオボタンは横幅に応じてラップする
.reservation-type-radios {
  flex-wrap: wrap;
}
.right-side {
  margin-left: 8px;
}
// ラジオボタンが2つしかないのでラップされることはありえないのでマージン調整
.register-radio-label {
  margin: 0 8px 0 0 !important;
}
</style>
